import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Inset } from 'syf-component-library/ui/spacing';
import UserItem from './utils/UserItem';
import { UserListTitle, UserListWrapper } from './utils/subcomponents';
import { PAGE_NAME, SAMS_PAGE_NAME } from '../../../const/analytics';
import triggerManageCardHoldersAnalytics from '../../../helpers/trigger-manage-card-holders-analytics';
import triggerManageCardHoldersSamsAnalytics from '../../../helpers/trigger-manage-card-holders-sams-analytics';
import NoManageCardHoldersAdded from './utils/NoManageCardHoldersAdded';
import { CardholdersScreen } from '../../../typings';
import MaximumMessageBox from '../MaximumMessageBox';
import { translate } from '../../../strings/i18n';
import Note from './utils/Note';
const AuthorizedUsers = ({ authorizedUsers, remainingAuthUserAllowed, currentScreen, isSamsClient = false }) => {
    const isNewUserConfirmation = currentScreen === CardholdersScreen.CONFIRMATION_SCREEN_NEW_USER;
    const authorizedUsersData = authorizedUsers && authorizedUsers?.authorizedUsers;
    const hasEmptyAuthorizedUsersData = !authorizedUsersData?.length;
    const hasReachedMaximumLimit = remainingAuthUserAllowed &&
        remainingAuthUserAllowed === '0' &&
        !isNewUserConfirmation;
    useEffect(() => {
        if (isSamsClient) {
            if (isNewUserConfirmation) {
                triggerManageCardHoldersSamsAnalytics({
                    pageName: SAMS_PAGE_NAME.SUCCESS
                });
            }
            else if (hasReachedMaximumLimit) {
                triggerManageCardHoldersSamsAnalytics({
                    pageName: SAMS_PAGE_NAME.LIMIT_REACHED,
                    errorMessage: 'you have reached the maximum number of authorized users'
                });
            }
            else if (currentScreen === CardholdersScreen.INITIAL_SCREEN) {
                triggerManageCardHoldersSamsAnalytics({
                    pageName: SAMS_PAGE_NAME.START_VERIFIED
                });
            }
            else if (currentScreen === CardholdersScreen.VERIFY_USER_SCREEN) {
                triggerManageCardHoldersSamsAnalytics({
                    pageName: SAMS_PAGE_NAME.NOT_VERIFIED
                });
            }
        }
        else if (isNewUserConfirmation) {
            triggerManageCardHoldersAnalytics({
                pageName: PAGE_NAME.COMPLETE
            });
        }
        else if (hasReachedMaximumLimit) {
            triggerManageCardHoldersAnalytics({
                pageName: PAGE_NAME.LIMIT_REACHED
            });
        }
        else if (currentScreen === CardholdersScreen.INITIAL_SCREEN) {
            triggerManageCardHoldersAnalytics({
                pageName: PAGE_NAME.START
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasReachedMaximumLimit, isNewUserConfirmation, isSamsClient]);
    return (_jsxs(_Fragment, { children: [hasEmptyAuthorizedUsersData && _jsx(NoManageCardHoldersAdded, {}), hasReachedMaximumLimit && _jsx(MaximumMessageBox, {}), _jsxs(UserListWrapper, { "data-testid": "authorized-users", top: "base", children: [isNewUserConfirmation && (_jsx(UserListTitle, { weight: "light", isInline: true, children: translate('newAuthorizedUser.title') })), authorizedUsersData?.map((usersDetails) => {
                        return (_jsx(UserItem, { name: `${usersDetails['cipher.firstName']} ${usersDetails['cipher.lastName']}`, isNewUserConfirmation: isNewUserConfirmation }, usersDetails.authorizedUserId));
                    }), isNewUserConfirmation && (_jsx(Inset, { top: "medium", children: _jsx(Note, { text: "successfulMessageBox.waitTimeToBeReflected" }) }))] })] }));
};
export default AuthorizedUsers;
